import { VANI_API } from '@/config/env';
import { detectRedFlag, redFlagReply } from '@byonco/safety';

let navigateFn = null;

export function bindNavigate(fn) {
  navigateFn = fn;
}

export function applyActions(actions, { redFlag } = {}) {
  if (redFlag) return;
  if (!Array.isArray(actions) || !actions.length) return;
  for (const action of actions) {
    if (!action || !action.type) continue;
    if (action.type === 'navigate' || action.type === 'start_booking') {
      if (typeof navigateFn === 'function') navigateFn(action.path);
      continue;
    }
    if (action.type === 'fill_form') {
      window.dispatchEvent(new CustomEvent('vani:fill_form', { detail: action }));
      continue;
    }
    if (action.type === 'run_search') {
      window.dispatchEvent(new CustomEvent('vani:run_search', { detail: action }));
    }
  }
}

export async function sendAmbientTurn({ text, lang, route }) {
  const flag = detectRedFlag(text, { loose: true });
  if (flag.hit) {
    const reply = redFlagReply(lang);
    window.dispatchEvent(new CustomEvent('vani:red-flag', { detail: { text: reply, reasons: flag.reasons } }));
    return { text: reply, redFlag: true, reasons: flag.reasons, actions: [] };
  }

  const api = String(VANI_API || '').replace(/\/$/, '') + '/api';
  const r = await fetch(api + '/chat', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      system: 'You are Vani, a voice companion for cancer patients and families. Follow your standing safety rules.',
      messages: [{ role: 'user', content: text }],
      lang,
      route,
    }),
  });
  let body = null;
  try { body = await r.json(); } catch (_) {}
  if (r.status === 401) return { status: 401, text: '', redFlag: false, actions: [] };
  if (r.status === 402) return { status: 402, text: '', redFlag: false, actions: [], quota: body?.quota };
  if (!r.ok) throw new Error('chat_failed');

  if (body?.redFlag) {
    window.dispatchEvent(new CustomEvent('vani:red-flag', { detail: { text: body.text, reasons: body.reasons } }));
    return body;
  }
  applyActions(body?.actions, { redFlag: false });
  return body;
}

export { detectRedFlag, redFlagReply };
